// assets/routine-add-all.js
(function () {
  // Toggle to see debug logs when needed
  const DEBUG = false;
  const dlog = (...a) => { if (DEBUG) try { console.log('[RoutineAddAll]', ...a); } catch(_){} };

  // --- Drawer helpers (uses your MiniCart API) ---
  const openDrawerWithFreshSections = () => {
    const miniCart = document.querySelector('mini-cart');
    if (!miniCart || typeof miniCart.renderContents !== 'function') {
      // Fallback events (still quiet)
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'routine-4-products' } }));
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      return;
    }
    fetch('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble')
      .then((res) => res.json())
      .then((sections) => {
        miniCart.renderContents({ id: Date.now().toString(), sections });
      })
      .catch((e) => {
        // keep real errors visible
        console.error('[RoutineAddAll] sections fetch failed', e);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'routine-4-products' } }));
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      });
  };

  // Live availability check like your GWP
  const checkVariantAvailable = async (variantId) => {
    try {
      const res = await fetch(`/variants/${variantId}.js`, { credentials: 'same-origin' });
      if (!res.ok) return true; // let add.js validate if blocked
      const v = await res.json();
      return !!(v && v.available);
    } catch {
      return true;
    }
  };

  const formatMoney = (cents, fmt) => {
    try { return Shopify.formatMoney(cents, fmt || '${{amount}}'); }
    catch { return '$' + (cents / 100).toFixed(2); }
  };

  const initSection = (root) => {
    if (!root || root.dataset.routineInit === '1') return;
    root.dataset.routineInit = '1';

    const list  = root.querySelector('[data-list]');
    const addBtn = root.querySelector('[data-add-all]');
    if (!list || !addBtn) return;

    const LABELS = {
      label:   addBtn.dataset.label   || 'Add all',
      loading: addBtn.dataset.loading || 'Adding…',
      done:    addBtn.dataset.done    || 'Added!',
      error:   addBtn.dataset.error   || 'Try again'
    };
    const MONEY_FMT = addBtn.dataset.moneyFormat || '${{amount}}';

    const totalEl = addBtn.querySelector('[data-total]');
    const labelEl = addBtn.querySelector('.label');

    // --- Button total (sum of available items) ---
    const computeTotals = () => {
      const items = Array.from(list.querySelectorAll('[data-item]'))
        .filter(el => el.dataset.available === 'true');

      let total = 0;    // current
      let original = 0; // compare-at (fallback to price)
      for (const el of items) {
        const price   = parseInt(el.dataset.price   || '0', 10) || 0;   // cents
        const compare = parseInt(el.dataset.compare || el.dataset.price || '0', 10) || 0;
        total    += price;
        original += Math.max(compare, price);
      }

      if (!totalEl) return;
      if (original > total) {
        totalEl.innerHTML = `&nbsp;<s>${formatMoney(original, MONEY_FMT)}</s>&nbsp;${formatMoney(total, MONEY_FMT)}`;
      } else {
        totalEl.textContent = ' ' + formatMoney(total, MONEY_FMT);
      }
    };

    computeTotals();

    // --- Build items to add (1 of each) ---
    const buildItems = async () => {
      const ids = Array.from(new Set(
        Array.from(list.querySelectorAll('[data-item]'))
          .filter(el => el.dataset.available === 'true')
          .map(el => Number(el.dataset.variantId))
          .filter(Boolean)
      ));
      dlog('ids', ids);
      const checks = await Promise.all(ids.map(async id => (await checkVariantAvailable(id)) ? id : null));
      const items = checks.filter(Boolean).map(id => ({ id, quantity: 1 }));
      dlog('items', items);
      return items;
    };

    let inflight = false;
    const onAddAll = async () => {
      if (inflight) return;
      inflight = true;

      const old = labelEl ? labelEl.textContent : '';
      addBtn.disabled = true;
      if (labelEl) labelEl.textContent = LABELS.loading;

      try {
        const items = await buildItems();
        if (!items.length) throw new Error('No available items');

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('Cart add failed');

        if (labelEl) labelEl.textContent = LABELS.done;

        // Re-render + open drawer
        openDrawerWithFreshSections();
      } catch (e) {
        console.error('[RoutineAddAll] add error', e); // keep errors visible
        if (labelEl) labelEl.textContent = LABELS.error;
      } finally {
        setTimeout(() => {
          if (labelEl) labelEl.textContent = old || LABELS.label;
          addBtn.disabled = false;
          inflight = false;
        }, 1200);
      }
    };

    addBtn.addEventListener('click', onAddAll);
  };

  const scan = () => document.querySelectorAll('section[data-routine]').forEach(initSection);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', (e) => initSection(e.target));
  document.addEventListener('page:load', scan);
  document.addEventListener('swup:contentReplaced', scan);
})();
